/**
 * @author LB
 * @description 报表路由
 */
export default [
  /*************业务报表**************************************/
  {
    path: '/reportForm/businessReportForm/payDetail',
    name: 'reportForm_payDetail',
    meta: {
      title: '付款明细',
      pageId: 'payDetail',
      pageName: '付款明细',
      parentId: 'businessReportForm',
      parentName: '业务报表',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/reportForm/businessReportForm/payDetail'], resolve),
  },
  {
    path: '/reportForm/businessReportForm/businessRecord',
    name: 'reportForm_businessRecord',
    meta: {
      title: '业务计件表(旧)',
      pageId: 'businessRecord',
      pageName: '业务计件表(旧)',
      parentId: 'businessReportForm',
      parentName: '业务报表',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/reportForm/businessReportForm/businessRecord'], resolve),
  },
  {
    path: '/reportForm/businessReportForm/businessReckonPiece',
    name: 'reportForm_businessReckonPiece',
    meta: {
      title: '业务计件表',
      pageId: 'businessReckonPiece',
      pageName: '业务计件表',
      parentId: 'businessReportForm',
      parentName: '业务报表',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/reportForm/businessReportForm/businessReckonPiece'], resolve),
  },
  {
    path: '/reportForm/businessReportForm/pieceworkSalary',
    name: 'reportForm_pieceworkSalary',
    meta: {
      title: '薪酬计件表',
      pageId: 'pieceworkSalary',
      pageName: '薪酬计件表',
      parentId: 'businessReportForm',
      parentName: '业务报表',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/reportForm/businessReportForm/pieceworkSalary'], resolve),
  },
  {
    path: '/reportForm/businessReportForm/crossRegionCostAdjustment',
    name: 'reportForm_crossRegionCostAdjustment',
    meta: {
      title: '跨区成本调整',
      pageId: 'crossRegionCostAdjustment',
      pageName: '跨区域成本调整',
      parentId: 'businessReportForm',
      parentName: '业务报表',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/reportForm/businessReportForm/crossRegionCostAdjustment'], resolve),
  },
  {
    path: '/reportForm/businessReportForm/enterprisePiecework',
    name: 'reportForm_enterprisePiecework',
    meta: {
      title: 'B端计件',
      pageId: 'enterprisePiecework',
      pageName: 'B端计件',
      parentId: 'businessReportForm',
      parentName: '业务报表',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/reportForm/businessReportForm/enterprisePiecework'], resolve),
  },
  {
    path: '/reportForm/businessReportForm/lostCustomer',
    name: 'reportForm_lostCustomer',
    meta: {
      title: '流失客户表',
      pageId: 'lostCustomer',
      pageName: '流失客户表',
      parentId: 'businessReportForm',
      parentName: '业务报表',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/reportForm/businessReportForm/lostCustomer'], resolve),
  },
  {
    path: '/reportForm/businessReportForm/financialRevenue',
    name: 'reportForm_financialRevenue',
    meta: {
      title: '财务收支',
      pageId: 'financialRevenue',
      pageName: '财务收支',
      parentId: 'businessReportForm',
      parentName: '业务报表',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/reportForm/businessReportForm/financialRevenue'], resolve),
  },
  {
    path: '/reportForm/businessReportForm/platformStatistics',
    name: 'reportForm_platformStatistics',
    meta: {
      title: '平台统计',
      pageId: 'platformStatistics',
      pageName: '平台统计',
      parentId: 'businessReportForm',
      parentName: '业务报表',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/reportForm/businessReportForm/platformStatistics'], resolve),
  },
  {
    path: '/reportForm/businessReportForm/overtimeReportForm',
    name: 'reportForm_overtimeReportForm',
    meta: {
      title: '超时报表',
      pageId: 'overtimeReportForm',
      pageName: '超时报表',
      parentId: 'businessReportForm',
      parentName: '业务报表',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/reportForm/businessReportForm/overtimeReportForm'], resolve),
  },
  {
    path: '/reportForm/businessReportForm/appointTaskReportForm',
    name: 'reportForm_appointTaskReportForm',
    meta: {
      title: '指定报表',
      pageId: 'appointTaskReportForm',
      pageName: '指定报表',
      parentId: 'businessReportForm',
      parentName: '业务报表',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/reportForm/businessReportForm/appointTaskReportForm'], resolve),
  },
  {
    path: '/reportForm/businessReportForm/onePassReportForm',
    name: 'reportForm_onePassReportForm',
    meta: {
      title: '报告一次性通过率',
      pageId: 'onePassReportForm',
      pageName: '报告一次性通过率',
      parentId: 'businessReportForm',
      parentName: '业务报表',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/reportForm/businessReportForm/onePassReportForm'], resolve),
  },

  /*************用户报表**************************************/
  {
    path: '/reportForm/userReportForm/userRecommend',
    name: 'reportForm_userRecommend',
    meta: {
      title: '用户推荐',
      pageId: 'userRecommend',
      pageName: '用户推荐',
      parentId: 'userReportForm',
      parentName: '用户报表',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/reportForm/userReportForm/userRecommend'], resolve),
  },
  {
    path: '/reportForm/userReportForm/taskUserDistribution',
    name: 'reportForm_taskUserDistribution',
    meta: {
      title: '任务用户分布',
      pageId: 'taskUserDistribution',
      pageName: '任务用户分布',
      parentId: 'userReportForm',
      parentName: '用户报表',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/reportForm/userReportForm/taskUserDistribution'], resolve),
  },
  {
    path: '/reportForm/userReportForm/guestDistribution',
    name: 'reportForm_guestDistribution',
    meta: {
      title: '用户分布图',
      pageId: 'guestDistribution',
      pageName: '用户分布图',
      parentId: 'userReportForm',
      parentName: '用户报表',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/reportForm/userReportForm/guestDistribution'], resolve),
  },

  /*************抽签报表**************************************/
  {
    path: '/reportForm/drawReportForm/businessDistrictRegistration',
    name: 'reportForm_businessDistrictRegistration',
    meta: {
      title: '商圈情况',
      pageId: 'businessDistrictRegistration',
      pageName: '商圈情况',
      parentId: 'drawReportForm',
      parentName: '抽签报表',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/reportForm/drawReportForm/businessDistrictRegistration'], resolve),
  },
  {
    path: '/reportForm/drawReportForm/winningDetail',
    name: 'reportForm_winningDetail',
    meta: {
      title: '中奖明细',
      pageId: 'winningDetail',
      pageName: '中奖明细',
      parentId: 'drawReportForm',
      parentName: '抽签报表',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/reportForm/drawReportForm/winningDetail'], resolve),
  },
  /*************费用报表**************************************/
  {
    path: '/reportForm/costReportForm/virtualTelephoneStatistic',
    name: 'reportForm_virtualTelephoneStatistic',
    meta: {
      title: '虚拟电话统计',
      pageId: 'virtualTelephoneStatistic',
      pageName: '虚拟电话统计',
      parentId: 'costReportForm',
      parentName: '费用报表',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/reportForm/costReportForm/virtualTelephoneStatistic'], resolve),
  },
  {
    path: '/reportForm/costReportForm/companyRechargeReport',
    name: 'reportForm_companyRechargeReport',
    meta: {
      title: '企业充值表',
      pageId: 'companyRechargeReport',
      pageName: '企业充值表',
      parentId: 'costReportForm',
      parentName: '费用报表',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/reportForm/costReportForm/companyRechargeReport'], resolve),
  },
  /*************数据看板**************************************/
  {
    path: '/reportForm/dataBoard/reportFormBI/:pathMatch(.*)*',
    name: 'reportForm_reportFormBI',
    meta: {
      title: 'BI报表',
      pageId: 'reportFormBI',
      pageName: 'BI报表',
      parentId: 'dataBoard',
      parentName: '数据看板',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/reportForm/dataBoard/reportFormBI'], resolve),
  },
  {
    path: '/reportForm/dataBoard/dataSubscribe/:pathMatch(.*)*',
    name: 'reportForm_dataSubscribe',
    meta: {
      title: '数据订阅',
      pageId: 'dataSubscribe',
      pageName: '数据订阅',
      parentId: 'dataBoard',
      parentName: '数据看板',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/reportForm/dataBoard/dataSubscribe'], resolve),
  },
  {
    path: '/reportForm/dataBoard/dataTemplate/:pathMatch(.*)*',
    name: 'reportForm_dataTemplate',
    meta: {
      title: '数据模板',
      pageId: 'dataTemplate',
      pageName: '数据模板',
      parentId: 'dataBoard',
      parentName: '数据看板',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/reportForm/dataBoard/dataTemplate'], resolve),
  },
  {
    path: '/reportForm/dataBoard/viewList/:pathMatch(.*)*',
    name: 'reportForm_viewList',
    meta: {
      title: '数据集',
      pageId: 'viewList',
      pageName: '数据集',
      parentId: 'dataBuild',
      parentName: '数据搭建',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/reportForm/dataBuild/viewList'], resolve),
  },
  {
    path: '/reportForm/dataBoard/metadataManage/:pathMatch(.*)*',
    name: 'reportForm_metadataManage',
    meta: {
      title: '元数据管理',
      pageId: 'metadataManage',
      pageName: '元数据管理',
      parentId: 'dataBuild',
      parentName: '数据搭建',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/reportForm/dataBuild/metadataManage'], resolve),
  },
];
